import { Backdrop, Drawer, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { useLayersDrawerState } from 'features/mapping/hooks/useLayersDrawerState';
import { BlockingBottomSheet } from 'components/BlockingBottomSheet';
import {
  LAYERS_DRAWER_WIDTH,
  MOBILE_LAYER_DRAWER_HEIGHT,
} from 'features/mapping/mapping.constants';
import {
  DOWNLOAD_APP_BANNER_OFFSET_CSS_VALUE,
  TOOLBAR_HEIGHT_DESKTOP_PX,
} from '../../../../../constants';
import { DrawerGroupContent } from './DrawerGroupContent';

const useStyles = makeStyles()((theme) => ({
  drawer: {
    width: LAYERS_DRAWER_WIDTH,
  },
  drawerPaper: {
    paddingTop: `calc(${TOOLBAR_HEIGHT_DESKTOP_PX}px + env(safe-area-inset-top) + ${DOWNLOAD_APP_BANNER_OFFSET_CSS_VALUE})`,
    paddingBottom: `env(safe-area-inset-bottom)`,
    width: LAYERS_DRAWER_WIDTH,
    zIndex: theme.zIndex.drawer + 2,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: 'transparent',
  },
}));

export const LayersGroupDrawer = (): JSX.Element => {
  const { classes } = useStyles();
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('phone'));
  const { t } = useTranslation();
  const { open, group, closeLayersGroup } = useLayersDrawerState();

  // It is important to check if the layers drawer is already open and if the group is set.
  const isGroupDrawerOpen = open && Boolean(group);

  if (isPhone) {
    return (
      <BlockingBottomSheet
        id="layer-group-bottom-sheet"
        open={isGroupDrawerOpen}
        onDismiss={closeLayersGroup}
        skipInitialTransition
        snapPoints={(): number[] => [MOBILE_LAYER_DRAWER_HEIGHT]}
        expandOnContentDrag
        header
        scrollLocking
        aria-label={t('map.layers.accessibility.layersGroupDrawer')}
      >
        <DrawerGroupContent />
      </BlockingBottomSheet>
    );
  }

  return (
    <>
      <Backdrop
        open={isGroupDrawerOpen}
        onClick={closeLayersGroup}
        className={classes.backdrop}
      />

      <Drawer
        className={classes.drawer}
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="right"
        open={isGroupDrawerOpen}
        onClose={closeLayersGroup}
        variant="persistent"
        PaperProps={{
          'aria-label': t('map.layers.accessibility.layersGroupDrawer'),
        }}
      >
        <DrawerGroupContent />
      </Drawer>
    </>
  );
};
